import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanSectionModule } from '../../components/plan-section/plan-section.module';
import { PageTitleModule } from '../../components/page-title/page-title.module';
import { SelectionComponent } from './selection.component';

@NgModule({
    declarations: [SelectionComponent],
    imports: [
        CommonModule,
        PlanSectionModule,
        PageTitleModule,
    ],
    exports: [SelectionComponent],
})
export class SelectionModule {}
